import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import policy from './privacy_policy_070819.pdf';

const TermsPage = () => {
  const [pdfFile, setPdfFile] = useState('');
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [renderNavButtons, setRenderNavButtons] = useState(false);
  const onSuccess = (sample) => {
    setPageNumber(1);
    setRenderNavButtons(true);
  };
  useEffect(() => {
    setPdfFile(policy);
  }, []);

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const navigate = useNavigate();

  const previousPage = () => {
    changePage(-1);
  };
  const nextPage = () => {
    changePage(+1);
  };

  return (
    <>
      <div style={{ margin: 'auto', width: '30%', height: '20%' }}>
        <div>
          <div style={{ margin: 'auto', width: '40%' }}>
            <Button
              disabled={pageNumber <= 1}
              onClick={previousPage}
              variant='warning'
            >
              Previous Page
            </Button>
            {'  '}
            <Button
              disabled={pageNumber === numPages}
              onClick={nextPage}
              variant='warning'
            >
              Next Page
            </Button>
            {'  '}
          </div>
          <Document
            file={pdfFile}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages);
              setRenderNavButtons(true);
              onSuccess(pdfFile);
            }}
          >
            <Page pageNumber={pageNumber} />
          </Document>
          {renderNavButtons && (
            <div className='buttonc' style={{ margin: 'auto', width: '5%' }}>
              <Button
                variant='warning'
                onClick={() => {
                  navigate('/');
                }}
              >
                Agree
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default TermsPage;
